import { fidelityLabel } from '../core/fidelity';
import type { FidelityLevel } from '../core/types';

export interface FormatOption {
  format: string;
  /** 运行时能力是否可用（例如浏览器不支持 AVIF 编码时会被剔除）。 */
  available: boolean;
  /** 预期保真度，来自引擎声明，仅作提示。 */
  expectedFidelity?: FidelityLevel;
  /** 通道与单价提示（如「本地 1 分 / AI 2 分」），由能力注册表推导，UI 不硬编码。 */
  costHint?: string;
}

export interface FormatSelectProps {
  value: string;
  options: FormatOption[];
  disabled?: boolean;
  onChange: (format: string) => void;
  id?: string;
}

/** 目标格式选择：选项全部来自能力注册表，UI 不硬编码格式清单。 */
export function FormatSelect({ value, options, disabled, onChange, id = 'target-format' }: FormatSelectProps) {
  if (options.length === 0) {
    return (
      <div className="field">
        <label htmlFor={id}>目标格式</label>
        <div className="notice" data-tone="warn">
          当前文件类型暂无可用的本地转换目标格式。
        </div>
      </div>
    );
  }

  const selected = options.find((option) => option.format === value);
  return (
    <div className="field">
      <label htmlFor={id}>目标格式</label>
      <select id={id} className="select" value={value} disabled={disabled} onChange={(event) => onChange(event.target.value)}>
        {options.map((option) => (
          <option key={option.format} value={option.format} disabled={!option.available}>
            {option.format.toUpperCase()}
            {option.available ? '' : '（当前环境不可用）'}
            {option.costHint ? ` · ${option.costHint}` : ''}
            {option.expectedFidelity ? ` · 预期 ${fidelityLabel(option.expectedFidelity)}` : ''}
          </option>
        ))}
      </select>
      {selected?.expectedFidelity ? (
        <span className="card-hint">该组合的保真度与丢失项在转换完成后逐条列出，不使用「无损」笼统表述。</span>
      ) : null}
    </div>
  );
}
